<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:50px;">
            <h2>
                {{ submission.promoString }} ({{ submission.promo_year }})
            </h2>
            <span>
                &bull;<strong>SUBMITTED BY: </strong>{{ createdByUser }}
            </span>
            <br>
            <span v-if="submission.pp_status == 'e'">
                &bull;<strong>ENTERED INTO ERP: </strong>{{ erpUser }}
            </span>
            <table class="dppTBL">
                <tr>
                    <th>BT</th>
                    <th>COMPANY</th>
                    <th>PROMO DETAIL</th>
                    <th>PRICE LEVEL</th>
                    <th>PRICE BASIS</th>
                    <th>ORDER #</th>
                    <th>VOLUME</th>
                    <th v-if="submission.pp_status != 'e'" colspan="3" style="text-align:center;">
                        ACTIONS
                    </th>
                </tr>
                <tr>
                    <td>{{ submission.cust_id }}</td>
                    <td>{{ submission.company }}</td>
                    <td>{{ submission.promo_detail }}</td>
                    <td>{{ submission.price_level }}</td>
                    <td>{{ submission.price_basis }}</td>
                    <td>
                        <ul style="list-style-type:none;">
                            <li v-for="ordNum in ordNums">
                                {{ ordNum }}
                            </li>
                        </ul>
                    </td>
                    <td>{{ submission.initial_volume }}</td>
                    <td v-if="submission.pp_status != 'e' && submission.pp_status != 'd'" id="iconTd">
                        <router-link :to="{ name: 'PriceWorkflowPromoDetails', params: {ppId: this.ppId}}">
                            <img id="iconImg" src="/images/icon-circle-edit.png" />
                        </router-link>
                        <p id="iconLabel">EDIT</p>
                    </td>
                    <td v-if="submission.pp_status != 'e' && submission.pp_status != 'd'" id="iconTd">
                        <a v-on:click="openDenyForm()">
                            <img id="iconImg" src="/images/circle-x-red.png" style="height:26px; width:auto;">
                        </a>
                        <p id="iconLabel">DENY</p>
                    </td>
                    <td v-if="submission.pp_status != 'e'" id="iconTd">
                        <a v-on:click="deleteEntry();">
                            <img id="iconImg" src="/images/icon-circle-trash.png" />
                        </a>
                        <p id="iconLabel">DELETE</p>
                    </td>
                </tr>
            </table>
            <br>
            <p v-if="submission.pp_status == 'd'">
                <strong>DENIAL RATIONALE</strong><br>
                <textarea v-model="denialReason" style="width:40%;height:8rem;" readonly></textarea>
            </p>
            <form @submit.prevent="denyPromo" class="denialForm" style="display:none;">
                <strong>REASON FOR DENYING?</strong><br>
                <textarea v-model="denialReason" style="width:40%;height:8rem;"></textarea>
                <br>
                <button class="btn-round-green" type="submit">SUBMIT</button>
                <button class="btn-round-red" v-on:click="hideDenialForm();">CANCEL</button>
            </form>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    data() {
        return {
            createdByUser: "",
            denialReason: "",
            erpUser: "",
            ordNums: ["","","","","","","","","",""],
            submission: {},
        }
    },
    props: ['ppId'],
    created() {
        axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
            this.submission = response.data;

            this.createdByUser = this.submission.created_by_user.full_name;
            this.denialReason = this.submission.pricing_notes;

            if(this.submission.erp_user != null) {
                this.erpUser = this.submission.erp_user.full_name;
            }

            if(this.submission.ord_num != null) {
                let ordNums = this.submission.ord_num.split("|");
                this.ordNums = ordNums;
            }
        });
    },
    computed: {
        ...mapState({ user: state => state.user })
    },
    methods: {
        openDenyForm() {
            $(".denialForm").show();
        },
        hideDenialForm() {
            $(".denialForm").hide();
        },
        denyPromo() {
            let data = {
                denialReason: this.denialReason,
                ppId: this.ppId,
                userId: this.user.id,
            }

            axios.post(`/api/denyPromo`, data).then(response => {
                this.$router.push({
                    name: "PriceWorkflowDashboards"
                });
            });
        },
        deleteEntry() {
            if(confirm("Did you mean to click DELETE? This will remove the selected Promo from the database.")) {
                axios.post(`/api/deleteSubmission`, {ppId: this.ppId}).then(response => {
                    this.$router.push({
                        name: "PriceWorkflowDashboards"
                    });
                });
            }
        }
    }
}
</script>

<style scoped>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }

    .dppTBL {
        margin-top: 2rem;
        text-align: left !important;
        font-size: 0.8rem;
        width: 100%;
    }

    .dppTBL th {
        font-weight: bold;
        padding: 0rem 1rem 0.2rem 0rem;
        border-bottom: 1px solid #666;
    }

    .dppTBL td {
        padding: 1rem 1rem 1rem 0;
        background: #fff;
        border-bottom: dotted 1px #ccc;
    }

    #iconImg {
        height:26px; 
        width:auto;
    }

    #iconTd {
        text-align:center; 
        width:2%;
        cursor: pointer;
    }

    #iconLabel {
        font-size:0.6rem; 
        color:#999;
    }
</style>